<template>
  <div class="Investment-box">
    <div class="head-text">
      <h1>KeepSafe</h1>
    </div>
    <div class="card-box">
      <h4>Select your option</h4>
      <v-row>
      	<template>
          <v-card
          	v-for="categoryList in category"
          	:key="categoryList.id"
            class="mx-auto"
            outlined
            @click="subcategory(categoryList.id, categoryList.subcategory_name)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                	<v-img
        			max-height="39"
        			max-width="39"
        			:src="webIcon + categoryList.web_icon"
                	>
                	</v-img>
                </div>
                <v-list-item-title>{{categoryList.subcategory_name}}</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subcategory(categoryList.id, categoryList.subcategory_name)" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
          <v-card
            class="mx-auto"
            outlined
            @click="subcategory('', 'Tax Filing')"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                  <v-img
              max-height="39"
              max-width="39"
              src="https://dev-api.nimeya.ai/img/icons/tax_filling_web_icon.png"
                  >
                  </v-img>
                </div>
                <v-list-item-title>Tax Filing</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subcategory('', 'Tax Filing')" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>

          <v-card
            class="mx-auto"
            outlined
            @click="subcategory('', 'My WILL')"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
                  <v-img
              max-height="39"
              max-width="39"
              src="https://dev-api.nimeya.ai/img/icons/will_first.png"
                  >
                  </v-img>
                </div>
                <v-list-item-title>My WILL</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subcategory('', 'My WILL')" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { GET_KEEP_SAFE_CATEGORY_DATA } from "../../store/actions.type";

import { isEmpty } from 'lodash';
   export default {
      data: () => ({
       	category:'',
       	webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
      }),
      mounted (){
        Fire.$on("categoryData", () => {
          this.categoryData();
        });
        if (isEmpty(this.$store.getters.getKeepSafeCategoryData)) {
          this.categoryData();
        }
        else {
          let categoryData = this.$store.getters.getKeepSafeCategoryData.data;
          this.category    = categoryData;
        }
      },
      methods: {
        subcategory(category_id, category_name){
         
          if(category_name == 'Deposit Accounts'){
            this.$router.push({name: 'DepositKeepSafe', params: {category: category_id, category_name:category_name, props: true}})
          }
          else if(category_name == 'Mutual Funds'){
            this.$router.push({name: 'MutualFundKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Real Estate'){
            this.$router.push({name: 'RealEstateKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Equities & Bonds'){
            this.$router.push({name: 'EquitiesBondsKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Insurance'){
            this.$router.push({name: 'InsuranceKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Retirement'){
            this.$router.push({name: 'RetirementKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Bullions'){
            this.$router.push({name: 'BullionsKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Commodities'){
            this.$router.push({name: 'CommodityKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Private Investment'){
            this.$router.push({name: 'PrivateInvestmentKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'Tax Filing'){
            this.$router.push({name: 'TaxFillingKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
          else if(category_name == 'My WILL'){
            this.$router.push({name: 'MyWillKeepSafe', params: {category: category_id, category_name:category_name, props: true}}) 
          }
        },
        categoryData(){
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          this.$store.dispatch(GET_KEEP_SAFE_CATEGORY_DATA, {
            data: {
              aws_cognito_id:cognito_idp,
              category_id:2,
            },
            api: 'subcategory-listing',
          })
          .then(() => {
            let categoryData = this.$store.getters.getKeepSafeCategoryData.data;
            this.category = categoryData;
          });
        }
    }
}
</script>